import ImageLightbox from '@/js/ImageLightbox';
import { componentProvider } from 'js-component-framework/es';

/**
 * Image Lightbox component config.
 */
const imageLightboxConfig = {
  name: 'image-lightbox',
  component: ({ element }) => new ImageLightbox(element),
};

componentProvider(imageLightboxConfig);
